<div fxLayout="row" fxLayoutAlign="start start">
  <mat-card [fxFlex]="companyEntity ? 50 : 100">
    <mat-card-content>
      <div *ngIf="companyEntity" class="m-b-10" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <img *ngIf="editCollapsed" class="image-placeholder" alt="Company Logo"
              [src]="logoUrl || '/assets/images/no-image-icon.svg'">
          <mat-menu #imageMenu="matMenu">
          <select-logo-menu 
          [parent]="imageMenu"
          [(uri)]="logoUrl"
          [(logoId)]="logoId"
          [companyId]="id"></select-logo-menu>
        </mat-menu>
        <button *ngIf="!editCollapsed" type="null" class="image-placeholder" mat-button #menuTrigger="matMenuTrigger"
        [ngClass]="{'empty': !logoUrl}" 
        [matMenuTriggerFor]="imageMenu">
          <span *ngIf="!logoUrl">Select Logo</span>
          <img *ngIf="logoUrl" [src]="logoUrl">
        </button>
          <div fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="center center">
            <span [ngClass.lt-sm]="{'card-title': true}" [matTooltip]="companyEntity?.id">{{ companyEntity?.name
              }}</span>
            <small class="text-info">{{ companyTypes[companyEntity.type] }}</small>
          </div>
        </div>
        <div>
          <button mat-icon-button>
            <mat-icon *ngIf="editCollapsed" matTooltip="Edit Company" color="accent"
              (click)="editCollapsed = false">edit</mat-icon>
            <mat-icon *ngIf="!editCollapsed" matTooltip="Cancel Edit" color="basic"
              (click)="editCollapsed = true">clear</mat-icon>
          </button>
        </div>
      </div>
      <form [fxShow]="!editCollapsed || !companyEntity" [formGroup]="manufacturerForm" (ngSubmit)="onSubmit()">
        <div fxLayout="row wrap" fxFlexAlign="center" class="row">
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>Name</mat-label>
            <input type="text" matInput formControlName="name" placeholder="Company Name">
            <mat-error *ngIf="form.name.hasError('required')">
              Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>Code</mat-label>
            <input type="text" matInput formControlName="code" placeholder="Code">
            <mat-error *ngIf="form.code.hasError('required')">
              Code is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <input matInput type="text" placeholder="Parent company" matInput formControlName="parentCompanyId"
              [matAutocomplete]="companyAuto">
            <mat-autocomplete #companyAuto="matAutocomplete" [displayWith]="displayCompanyName">
              <mat-option *ngFor="let company of filteredCompanies | async" [value]="company.id">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                  <img class="company-logo" *ngIf="company?.logoUrl" [lazyLoad]="company.logoUrl"
                    [matTooltip]="company.name" />
                  <span [innerHtml]="company.name | encodeHtml | highlight: companyControl.value"></span>
                </div>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>Locale</mat-label>
            <input type="text" matInput formControlName="locale" placeholder="Locale">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>TimeZone</mat-label>
            <input type="text" matInput formControlName="timeZone" placeholder="TimeZone">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>Type</mat-label>
            <mat-select matInput formControlName="type" placeholder="Type">
              <mat-option [value]="0">Builder</mat-option>
              <mat-option [value]="1">Manufacturer</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="100" class="p-10">
            <mat-label>Website</mat-label>
            <input type="text" matInput formControlName="website" placeholder="Website">
          </mat-form-field>
        </div>
        <div fxLayoutAlign="end center" fxLayoutGap="15px">
          <button type="submit" matTooltip="Save Changes" class="add-action-button" mat-flat-button color="primary"
            [disabled]="!manufacturerForm.valid">
            <mat-icon>done</mat-icon>Save
          </button>
          <button type="button" matTooltip="Return to Company List" class="reset-button" mat-stroked-button
            color="basic" (click)="showManufacturersView()">
            <mat-icon>clear</mat-icon>Back
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="companyEntity" fxFlex="50">
    <mat-card-content fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-card class="w-100">
        <mat-card-content fxLayout="column" fxLayoutAlign="center center">
          <div class="text-info m-b-20 display-number">
            {{ userCount }}
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span>Users</span>
            <a [routerLink]="['/admin/user']" mat-icon-button color="accent" matTooltip="Manage Users">
              <mat-icon>settings</mat-icon>
            </a>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="homeCount > 0" class="w-100">
        <mat-card-content fxLayout="column" fxLayoutAlign="center center">
          <div class="text-info m-b-20 display-number">
            {{ homeCount }}
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span>Homes</span>
            <a [routerLink]="['/homes/dashboard']" mat-icon-button color="accent" matTooltip="Manage Homes">
              <mat-icon>settings</mat-icon>
            </a>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card class="w-100">
        <mat-card-content fxLayout="column" fxLayoutAlign="center center">
          <div class="text-info m-b-20 display-number">
            {{ productCount }}
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span>Products</span>
            <a [routerLink]="['/products/catalog']" [queryParams]="{ company: id }" mat-icon-button color="accent"
              matTooltip="Manage Products">
              <mat-icon>settings</mat-icon>
            </a>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="productCount > 0" class="w-100">
        <mat-card-content fxLayout="column" fxLayoutAlign="center center">
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span>Marketing Material</span>
            <a [routerLink]="['/products/marketing']" mat-icon-button color="accent" matTooltip="Manage Marketing Material">
              <mat-icon>settings</mat-icon>
            </a>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>

<app-company-report-subscriptions
  *ngIf="!isAddMode && companyEntity"
  [companyId]="id"
  [companyName]="companyEntity.name ?? ''"
  [companies]="allCompanies">
</app-company-report-subscriptions>

<ng-template #marketingPanelTemplate let-mPanel let-only>

</ng-template>